import React from "react";
import { Link } from "react-router-dom";
import { Phone, Envelope, MapPin, FacebookLogo, Sparkle } from "@phosphor-icons/react";
import { useLang } from "../../context/LanguageContext";
import { LOGO_URL } from "../../lib/assets";
import { scrollToId } from "../../hooks/useLenis";

const scrollTo = (id) => scrollToId(id);

export default function Footer() {
  const { t } = useLang();
  return (
    <footer id="contact" className="relative bg-forest-deep text-white pt-24 pb-10 overflow-hidden grain">
      <div className="absolute -bottom-40 left-1/2 -translate-x-1/2 h-96 w-[60rem] rounded-full bg-leaf/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* brand */}
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_URL} alt="Kelsy" className="h-14 w-14 rounded-xl object-cover" />
              <div>
                <div className="font-serif text-2xl">Kelsy Housecleaning</div>
                <div className="text-[11px] uppercase tracking-[0.3em] text-leaf font-semibold">Ottawa · Gatineau</div>
              </div>
            </div>
            <p className="mt-6 text-white/60 max-w-sm leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm text-gold font-semibold">
              <Sparkle size={16} weight="fill" /> {t.why.tagline}
            </div>
          </div>

          {/* nav */}
          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-white/40 font-bold">{t.footer.quick}</div>
            <div className="mt-5 flex flex-col gap-3">
              {["services", "why", "areas", "quote"].map((id) => (
                <button key={id} onClick={() => scrollTo(id)} className="text-left text-white/70 hover:text-white transition-colors" data-testid={`footer-link-${id}`}>
                  {t.nav[id] || id}
                </button>
              ))}
              <Link to="/admin" className="text-left text-gold hover:text-gold/80 transition-colors" data-testid="footer-admin">{t.nav.admin}</Link>
            </div>
          </div>

          {/* contact */}
          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-white/40 font-bold">{t.footer.contactTitle}</div>
            <div className="mt-5 space-y-4">
              <a href="tel:3435436442" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors" data-testid="footer-phone">
                <Phone size={18} weight="fill" className="text-leaf" /> 343 543 6442
              </a>
              <a href="mailto:Kelsyhousecleaning@gmail.com" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors break-all" data-testid="footer-email">
                <Envelope size={18} weight="fill" className="text-leaf" /> Kelsyhousecleaning@gmail.com
              </a>
              <div className="flex items-center gap-3 text-white/80"><MapPin size={18} weight="fill" className="text-leaf" /> Ottawa, Ontario</div>
              <div className="flex items-center gap-3 text-white/80"><FacebookLogo size={18} weight="fill" className="text-leaf" /> Kelsy Housecleaning Ottawa</div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <div>© {new Date().getFullYear()} Kelsy Housecleaning Ottawa. {t.footer.rights}</div>
          <div className="font-serif italic text-white/70">Maison propre · Esprit léger</div>
        </div>
      </div>
    </footer>
  );
}
